
import Vue from 'vue'
import Notifications from '@/components/notifications/Notifications.vue'
import RLayout from '@/layouts/index.vue'
import { mapGetters } from 'vuex'
import { getAppRootURL } from './config'

export default Vue.extend({
  head: {
    link: [{ rel: 'canonical', href: getAppRootURL(), id: 'canonical' }],
  },
  components: {
    Notifications,
    RLayout,
  },
  computed: {
    ...mapGetters({
      theme: 'theme',
    }),
  },
  watch: {
    $route: {
      handler: function (to) {
        document.title = to.meta.title || 'Renderro'
      },
      immediate: true,
    },
  },
})
